import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import LinearProgress from '@material-ui/core/LinearProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import PersonIcon from '@material-ui/icons/Person'
import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import useTypedSelector from '../../hooks/useTypedSelector'
import { editingStart } from '../../store/people/peopleActions'
import PeopleListSearch from './PeopleListSearch'

export default function PeopleList() {
  const people = useTypedSelector(({ peopleState }) => peopleState.people)
  const searchQuery = useTypedSelector(
    ({ peopleState }) => peopleState.searchQuery
  )

  const filteredPeople = useMemo(() => {
    if (!searchQuery) {
      return people
    }
    return people.filter((person) =>
      person.name.toLowerCase().startsWith(searchQuery.toLowerCase().trim())
    )
  }, [people, searchQuery])

  const { selectedIndex, isEditing, isLoading } = useTypedSelector(
    ({ peopleState }) => {
      return {
        selectedIndex: peopleState.selectedIndex,
        isEditing: peopleState.isEditing,
        isLoading: peopleState.loadingPeople,
      }
    }
  )

  const dispatch = useDispatch()
  const onClickItem = (index: number) => () => {
    if (!searchQuery) {
      dispatch(editingStart(index))
    } else {
      const person = filteredPeople[index]
      const originalIndex = people.findIndex((item) => item.id === person.id)
      dispatch(editingStart(originalIndex))
    }
  }

  const renderEmptyList = () => (
    <Box display="flex" justifyContent="center" color="gray" marginTop={1}>
      <Typography
        variant="caption"
        align="center"
        children="Nenhum registro encontrado"
      />
    </Box>
  )

  const renderListItem = (person: any, i: number) => (
    <div key={i}>
      <ListItem
        button
        onClick={onClickItem(i)}
        selected={!searchQuery && isEditing && selectedIndex === i}
      >
        <ListItemAvatar>
          {person.image ? (
            <Avatar alt={`Foto de ${person.name}`} src={person.image.sm} />
          ) : (
            <Avatar>
              <PersonIcon />
            </Avatar>
          )}
        </ListItemAvatar>
        <ListItemText primary={person.name} secondary={person.status} />
      </ListItem>
      <hr className="ml-16" />
    </div>
  )

  return (
    <>
      <PeopleListSearch />
      {isLoading ? (
        <LinearProgress />
      ) : (
        <List>
          {!filteredPeople.length
            ? renderEmptyList()
            : filteredPeople.map(renderListItem)}
        </List>
      )}
    </>
  )
}
